import { forwardRef, useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Divider,
  ListItemText,
  List,
  ListItem,
  Typography,
  ListSubheader,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  ListItemIcon,
  MenuItem,
  Select,
  Tabs,
  Tab,
  Slide,
  FormControl,
  InputLabel,
  Avatar,
  Menu,
  InputAdornment,
} from "@mui/material";
import pr from "../lib/pr";
import axios from "axios";
import { configState } from "../lib/State";
import get_token from "../lib/get_token";
import add_comma from "../lib/add_comma";
import Swal from "sweetalert2";
import get_cid from '../lib/get_cid';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function BuyDiscountCoupon(props) { // 쿠폰구매 > 내 할인쿠폰
  
  const token = get_token();
  const { login, total, setUseCoupon, setCouponSeq } = props; // total : 최종_구매금액
  const [open, setOpen] = useState(false);
  const [rows, setRows]= useState([]);
  const cid = get_cid();

  const openClick = () => {
    setUseCoupon(0);
    setOpen(true);
  };  
  const closeClick = () => {
    setOpen(false);
  };
  const load_data = async () => {
    let result = await axios.post(configState.api+"/gympass/my_coupon_discount", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    setRows(result.data.rows);
  }
  useEffect(()=>{       
    setUseCoupon(0); // 초기화
    load_data();
  },[]);

  const couponClick = (item) => {
    
    let coupon_price = 0;
    let min_price = item.min_price;
    let max_price = item.max_price;
    let coupon_seq = item.seq;
        
    // 할인금액 계산하기
    if(item.gubun==='할인율') {
      coupon_price = total/100 * item.rate;
    }
    if(item.gubun==='금액') {
      coupon_price = item.amount;
      max_price = item.amount;
    }

    // 최소금액 확인
    if(total < min_price) {
      Swal.fire('선택한 쿠폰은 사용할 수 없습니다.');
      return;
    }
    
    // 최대금액 제한
    if(coupon_price > max_price) {
      coupon_price = max_price;
    }    
    setUseCoupon(coupon_price);
    setOpen(false);
    setCouponSeq(coupon_seq);

    // pr('coupon_price='+coupon_price);
    // pr('rate='+item.rate);
    // pr('gubun='+item.gubun);
    // pr('min_price='+min_price);
    // pr('max_price='+max_price);    
  }

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={closeClick}
        TransitionComponent={Transition}
      >
        <Box>
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src="/img/back_button_black.png" onClick={closeClick} />
            <Box
              sx={{
                margin: "25px 0 0 10px",
                fontSize: "22px",
              }}
            >
              할인쿠폰
            </Box>
          </Box>
          <Divider />
          
          { rows.map((item, index )=>{
            return <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginTop: "20px",
            }}
          >
            <Box
              sx={{
                width: "90%",
                border: "1px solid #d8d8d8",
                borderRadius: "8px",
                padding: "10px",
              }}
              onClick={()=>{couponClick(item)}}
            >
              <Box
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                {item.name}
              </Box>
              <Box
                sx={{
                  marginTop: "5px",
                  fontSize: "15px",
                }}
              >
                유효기간 : {item.sdate} ~ {item.edate} <br/>
                { item.gubun==='할인율' ?
                <>{add_comma(item.min_price)}원 이상 구매시/최대할인 {add_comma(item.max_price)}원</>:
                <>{add_comma(item.min_price)}원 이상 구매시/최대할인 {add_comma(item.amount)}원</>
                }
              </Box>
            </Box>
          </Box> 
          }) }          

          { rows.length === 0 && 
          <Box sx={{ mt:3, width: "100%", textAlign: "center", fontSize:14 }}>
              사용 가능한 쿠폰이 없습니다.
          </Box> }

        </Box>
      </Dialog>

      <Box
        sx={{
          width: "90%",
          height: "30px",
          display: "flex",
          alignItems: "center",
        }}
        onClick={openClick}
      >
        <Box width="50%" fontSize={14} fontWeight="bold" textAlign="left">
          할인쿠폰 선택
        </Box>
        <Box
          sx={{
            width: "50%",
            textAlign: "right",
            fontSize: "14px",
            // color: "#8e8e8e",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {rows.length}개 보유
          <img
            src="/img/back_button_black.png"
            style={{ width: "24px", transform: "scale(-1)" }}
          />
        </Box>
      </Box>
    </>
  );
}

export default BuyDiscountCoupon;